const O365CredentialEntity = (client) => ({
  create: async (body) => await client.post(`/api/o365/credentials`, body),
  update: async (id, body) =>
    await client.put(`/api/o365/credentials/${id}`, body),
})

export default O365CredentialEntity
